// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sale-modal .main-grid {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.sale-modal .main-grid .best-seller-heading {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #000000;
}

.sale-modal .sub-grid {
  padding-top: 0 !important;
  max-height: 73vh;
  overflow-y: auto;
}

.sale-modal .sub-grid .table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.sale-modal .sub-grid .table-head th {
  font-family: "Karla";
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #000000;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-bottom: 1px solid #000000;
  position: sticky;
  top: 0;
  background-color: #ffffff; /* Keep header background consistent */
  z-index: 1;
}

.sale-modal .sub-grid .table-head th:first-child {
  text-align: start;
}

.sale-modal .sub-grid .table-head th:last-child {
  text-align: end;
}

.sale-modal .sub-grid .table-body tr:last-child td {
  border-bottom: none;
  padding-bottom: 0px !important;
}

.sale-modal .sub-grid .table-body td {
  font-family: "Karla";
  font-size: 18px;
  line-height: 22px;
  color: #000000;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-bottom: 1px solid rgba(68, 68, 68, 0.3);
}

.sale-modal .sub-grid .table-body td:first-child {
  font-weight: 500;
  text-align: start;
}

.sale-modal .sub-grid .table-body td:last-child {
  font-weight: 400;
  text-align: end;
}

.scrollable-grid {
  overflow-y: auto;
  max-height: 450px;
}

.scrollable-grid {
  scrollbar-width: none; /* Hides the scrollbar */
}

/* IE and Edge */
.scrollable-grid {
  -ms-overflow-style: none; /* Hides the scrollbar */
}

/* WebKit Scrollbar Styles */
.scrollable-grid::-webkit-scrollbar {
  width: 0;
  height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/SaleDetailsModal/saleDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,yBAAyB,EAAE,sCAAsC;EACjE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;AACjD;;AAEA,gBAAgB;AAChB;EACE,wBAAwB,EAAE,wBAAwB;AACpD;;AAEA,4BAA4B;AAC5B;EACE,QAAQ;EACR,SAAS;AACX","sourcesContent":[".sale-modal .main-grid {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n\n.sale-modal .main-grid .best-seller-heading {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  color: #000000;\n}\n\n.sale-modal .sub-grid {\n  padding-top: 0 !important;\n  max-height: 73vh;\n  overflow-y: auto;\n}\n\n.sale-modal .sub-grid .table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.sale-modal .sub-grid .table-head th {\n  font-family: \"Karla\";\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000000;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n  border-bottom: 1px solid #000000;\n  position: sticky;\n  top: 0;\n  background-color: #ffffff; /* Keep header background consistent */\n  z-index: 1;\n}\n\n.sale-modal .sub-grid .table-head th:first-child {\n  text-align: start;\n}\n\n.sale-modal .sub-grid .table-head th:last-child {\n  text-align: end;\n}\n\n.sale-modal .sub-grid .table-body tr:last-child td {\n  border-bottom: none;\n  padding-bottom: 0px !important;\n}\n\n.sale-modal .sub-grid .table-body td {\n  font-family: \"Karla\";\n  font-size: 18px;\n  line-height: 22px;\n  color: #000000;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n  border-bottom: 1px solid rgba(68, 68, 68, 0.3);\n}\n\n.sale-modal .sub-grid .table-body td:first-child {\n  font-weight: 500;\n  text-align: start;\n}\n\n.sale-modal .sub-grid .table-body td:last-child {\n  font-weight: 400;\n  text-align: end;\n}\n\n.scrollable-grid {\n  overflow-y: auto;\n  max-height: 450px;\n}\n\n.scrollable-grid {\n  scrollbar-width: none; /* Hides the scrollbar */\n}\n\n/* IE and Edge */\n.scrollable-grid {\n  -ms-overflow-style: none; /* Hides the scrollbar */\n}\n\n/* WebKit Scrollbar Styles */\n.scrollable-grid::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
